import { Matrix, MatrixItem } from '@99designs/emu';
import { DynamicDesignCard } from '../DynamicDesignCard/DynamicDesignCard';
import type { Design, SelectionState, UpdateType } from '../../types';

export interface DesignGridProps {
    designs: Design[];
    likedIds: number[];
    variant: SelectionState;
    onDesignUpdated: (design: Design, updateType: UpdateType) => void;
}

export function DesignGrid({ designs, likedIds, variant, onDesignUpdated }: DesignGridProps) {
    return (
        <Matrix columns={[2, 3, 4, 4]} space={['0.75bu', '1.5bu', '2bu']}>
            {designs.map((design, index) => (
                <MatrixItem key={index}>
                    <DynamicDesignCard
                        src={design.image}
                        displayName={design.designer.displayName}
                        designerId={design.designer.id}
                        designId={design.id}
                        liked={likedIds.includes(design.id as number)}
                        variant={variant}
                        minWidth={['160px', '170px', '190px', '210px']}
                        minHeight={['160px', '170px', '190px', '210px']}
                        onDesignUpdated={onDesignUpdated}
                    />
                </MatrixItem>
            ))}
        </Matrix>
    );
}
